import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router, Scroll } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "../environments/environment";
import { registerGlobalFunctions } from "../scripts/global-functions";
import { AuthService } from "./services/auth.service";
import { MessagingService } from "./messaging.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild("body") bodyRef: ElementRef;
  isLoggedIn$: boolean = false; // Using a boolean here since we're now waiting for the promise

  constructor(
    private router: Router,
    public authService: AuthService,
    private messagingService: MessagingService
  ) {}

  title = "MedicNow";

  scrollPosition = [];

  scrollSubscription;

  playSound(soundUrl: string) {
    console.log("play sounds");
    const audio = new Audio(soundUrl);
    audio.play().catch((error) => {
      console.error("Error playing audio:", error);
    });
  }

  // Modify ngOnInit to work with async logic
  async ngOnInit() {
    registerGlobalFunctions();

    console.log("AppComponent initialized");

    // Prompt the user for notification permissions
    // this.messagingService.requestPermissionAndGetToken();

    // Subscribe to new messages
    // this.messagingService.currentMessage.subscribe((msg) => {
    //   if (msg) {
    //     console.log("New message from BehaviorSubject:", msg);
    //   }
    // });

    console.log("Last release timestamp is set to:", environment.timeStamp);
    this.scrollSubscription = this.router.events
      .pipe(filter((e): e is Scroll => e instanceof Scroll))
      .subscribe((e) => {
        if (e.routerEvent.url === "/" || e.routerEvent.url === "/home") {
          this.scrollPosition = [];
        }

        if (e.position) {
          // backward
          setTimeout(() => {
            this.bodyRef.nativeElement.scrollTop = this.scrollPosition.pop();
          }, 10);
        } else if (e.anchor) {
          //anchor
          this.bodyRef.nativeElement.scroll(0, e.anchor);
        } else {
          // forward
          this.scrollPosition.push(this.bodyRef.nativeElement.scrollTop);
          setTimeout(() => {
            this.bodyRef.nativeElement.scrollTop = 0;
          }, 10);
        }
      });

    // Request the initial login status asynchronously
    this.isLoggedIn$ = await this.authService.isLoggedIn(); // Await the promise returned by isLoggedIn()

    // Update login status on navigation change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(async () => {
        this.isLoggedIn$ = await this.authService.isLoggedIn(); // Re-fetch login status asynchronously
        console.log("Updated login status after navigation:", this.isLoggedIn$);
      });

    // Request permission and handle foreground messages
    // this.messagingService.requestPermission();
    // this.messagingService.receiveMessage();
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }
}
